export type PreferenceRouteId =
  | 'cooperation-membership'
  | 'zest-magazine'
  | 'customer-panel'
  | 'display'

export const preferenceRoutes: Record<
PreferenceRouteId,
{
  cardDescription: string
  cardTitle: string
  path: string
  title: string
}
> = {
  'cooperation-membership': {
    path: '/mijn-profiel/voorkeuren/lidmaatschap',
    title: 'Lidmaatschap',
    cardTitle: 'Lidmaatschap coöperatie Nh1816',
    cardDescription: 'Pas voorkeur aan voor lidmaatschap'
  },
  'zest-magazine': {
    path: '/mijn-profiel/voorkeuren/zest-magazine',
    title: 'Zest Magazine',
    cardTitle: 'Zest Magazine',
    cardDescription: 'Pas voorkeur aan voor ontvangen'
  },
  'customer-panel': {
    path: '/mijn-profiel/voorkeuren/klantenpanel',
    title: 'Klantenpanel',
    cardTitle: 'Klantenpanel',
    cardDescription: 'Pas voorkeur aan voor deelname'
  },
  display: {
    path: '/mijn-profiel/voorkeuren/beeldscherm',
    title: 'Beeldscherm',
    cardTitle: 'Beeldscherm',
    cardDescription: 'Wil je een donkere of lichte achtergrond'
  }
}
